export const PERMISSIONS_KEY = 'permissions';
export const SHARED_FOLDER_CREATOR = 'shared-folder-creator';
export const SHARED_FOLDER_VIEWER = 'shared-folder-viewer';
export const CONTENT_CREATOR_VIEW_ONLY = 'cc-view-only';
